import React from 'react';
import { injectStripe, IbanElement } from 'react-stripe-elements';
import { Button } from 'framework7-react';
import II18 from '../translate/II18';
import PropTypes from 'prop-types';

class SepaForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      email: '',
      ibanInvalid: true
    };
  }

  handleSubmit = () => {
    const { name, email } = this.state;
    const thiss = this;
    this.attemts = 0;
    if (this.props.stripe) {
      const ibanElement = this.props.elements.getElement('iban');

      this.startProcessing();

      this.props.stripe
        .confirmSepaDebitPayment(this.props.stripeClientSecret, {
          payment_method: {
            sepa_debit: ibanElement,
            billing_details: {
              name: name,
              email: email
            }
          }
        })
        .then(function(result) {
          if (result.error) {
            thiss.stopProcessing();
            if (
              result.error.payment_intent &&
              result.error.payment_intent.status === 'succeeded'
            ) {
              thiss.props.onPaymentSuccess();
            } else {
              // Show error to your customer (e.g., insufficient funds)

              thiss.props.onPaymentError(result.error.message);
            }
          } else {
            // The payment has been processed!
            if (result.paymentIntent.status === 'succeeded') {
              thiss.stopProcessing();
              thiss.props.onPaymentSuccess();
            } else if (result.paymentIntent.status === 'processing') {
              thiss.stopProcessing();
              thiss.props.onPaymentSuccess('sepa');
            } else {
              thiss.stopProcessing();
              thiss.props.onPaymentError(
                result.paymentIntent.last_payment_error.message
              );
            }
          }
        });
    } else {
      console.log("Stripe.js hasn't loaded yet.");
    }
  };

  startProcessing = () => {
    this.$f7.dialog.preloader(II18.get('dialog_processing'));
  };

  stopProcessing = () => {
    this.$f7.dialog.close();
  };

  /*checkPaymnet = () => {
    this.attemts++;
    const thiss = this;
    this.props.stripe
      .retrievePaymentIntent(this.props.stripeClientSecret)
      .then(function(response) {
        console.log(response);
        if (response.error) {
          thiss.props.onPaymentError(response.error.message);
        } else {
          if (response.paymentIntent.status === 'succeeded' || thiss.attemts === 5) {
            thiss.stopProcessing();
            thiss.props.onPaymentSuccess(response.paymentIntent.status !== 'succeeded');
          } else {
            if (response.paymentIntent.status === 'processing') {
              setTimeout(thiss.checkPaymnet, 1000);
            } else {
              thiss.stopProcessing();
              thiss.props.onPaymentError(
                response.paymentIntent.last_payment_error.message
              );
            }
          }
        }
      });
  };*/

  ibanChange = e => {
    this.setState({ ibanInvalid: !e.complete });
  };

  render() {
    const { name, email, ibanInvalid } = this.state;

    const emailNotValid =
      this.userEmail && email && !this.userEmail.checkValidity();
    const notValid = ibanInvalid || emailNotValid || !name;

    const createOptions = (fontSize, padding) => {
      return {
        style: {
          base: {
            fontSize,
            color: '#424770',
            letterSpacing: '0.025em',
            fontFamily: 'Source Code Pro, monospace',
            '::placeholder': {
              color: '#aab7c4'
            },
            padding
          },
          invalid: {
            color: '#9e2146'
          }
        }
      };
    };

    /*const formattedAmount = new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount);*/

    return (
      <div>
        <label className={'sepaFormElement'}>
          <II18>common_name</II18>
          <span className={'StripeElement text'}>
            <input
              style={{ width: '100%' }}
              ref={el => {
                this.userName = el;
              }}
              name="name"
              type="text"
              required
              value={name}
              onChange={e => this.setState({ name: e.target.value })}
            />
          </span>
        </label>
        <label className={'sepaFormElement'}>
          <II18>common_email</II18>
          <span
            className={'StripeElement text' + (emailNotValid ? ' error' : '')}
          >
            <input
              ref={el => {
                this.userEmail = el;
              }}
              style={{ width: '100%' }}
              value={email}
              onChange={e => this.setState({ email: e.target.value })}
              name="email"
              type="email"
              required
            />
          </span>
        </label>
        <label>
          <II18>payment_iban</II18>
          <IbanElement
            onChange={this.ibanChange}
            supportedCountries={['SEPA']}
            {...createOptions(this.props.fontSize)}
          />
        </label>
        <p>
          <II18>payment_sepa_long_information</II18>
        </p>
        <Button
          onClick={this.handleSubmit}
          className={'payButton'}
          fill
          disabled={notValid === true}
          style={{ maxWidth: 400, margin: '0 auto', fontSize: 14 }}
        >
          <II18>payment_confirm_sepa</II18>
        </Button>
      </div>
    );
  }
}

SepaForm.propTypes = {
  stripe: PropTypes.object,
  elements: PropTypes.object,
  fontSize: PropTypes.object,
  stripeClientSecret: PropTypes.string,
  paymentMethodTypes: PropTypes.array,
  amount: PropTypes.number
};

export default injectStripe(SepaForm);
